import React from 'react';
export function PromiseSection() {
  const transformations = [{
    icon: '☽',
    title: 'Dormís sin bucles nocturnos',
    description: 'Las noches de rumia terminan. Tu mente deja de recorrer escenas del pasado porque ya no quedan "pestañas abiertas" que procesar.'
  }, {
    icon: '✦',
    title: 'Estás presente de verdad',
    description: 'Dejás de estar físicamente en un lugar y mentalmente en otro. Tu atención vuelve a vos, a lo que está pasando ahora.'
  }, {
    icon: '◈',
    title: 'Los detonantes pierden fuerza',
    description: 'Una canción, una fecha, un olor ya no te devuelven al estado emocional original. Podés escucharlos sin que te cambie el cuerpo.'
  }, {
    icon: '❋',
    title: 'Entrás a lo nuevo sin cargar lo anterior',
    description: 'Nueva relación, nuevo trabajo, nueva etapa. Sin comparar. Sin la sombra de lo que no cerró. Limpia, entera, vos.'
  }, {
    icon: '◉',
    title: 'Recuperás tu energía',
    description: 'Cargar emociones no resueltas es físicamente agotador. Cuando algo cierra de verdad aparece una ligereza que no sabías que te faltaba.'
  }, {
    icon: '⟁',
    title: 'Sos dueña de tu mundo emocional',
    description: 'No a la merced de los recuerdos. El cierre es tuyo y lo generás vos. Sin depender de que el otro haga nada.'
  }];
  return <section id="promise" className="relative overflow-hidden text-center py-12 md:py-16 px-5 text-white" style={{
    background: 'linear-gradient(135deg, var(--ink) 0%, #3d2438 100%)'
  }} data-id="element-260">
      {/* Radial gradient overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 80% 50% at 50% 0%, rgba(200,169,110,.12) 0%, transparent 60%)'
    }} data-id="element-261" />

      <div className="relative max-w-[960px] mx-auto px-4" data-id="element-262">
        <h2 className="font-serif font-normal max-w-[700px] mx-auto mb-3" style={{
        fontSize: 'clamp(26px, 5vw, 46px)'
      }} data-id="element-263">
          Así se siente cuando algo
          <br data-id="element-264" />
          <em style={{
          color: 'var(--gold-light)',
          fontStyle: 'italic'
        }} data-id="element-265">
            finalmente cierra
          </em>
        </h2>

        <p className="max-w-[540px] mx-auto mb-8 md:mb-10" style={{
        fontSize: 'clamp(14px, 2vw, 17px)',
        color: 'rgba(255,255,255,.65)',
        lineHeight: 1.6
      }} data-id="element-266">
          Imaginate despertar mañana{' '}
          <strong style={{
          color: 'rgba(255,255,255,.85)',
          fontWeight: 400
        }} data-id="element-267">
            sin ese peso
          </strong>{' '}
          que hoy te acompaña a todas partes. Esto es lo que cambia cuando tu
          mente recibe <u data-id="element-268">el cierre que siempre mereció</u>.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 text-left" data-id="element-269">
          {transformations.map((item, index) => <div key={index} className="fade-in p-5 md:p-6 rounded transition-colors duration-300 hover:bg-white/10" style={{
          background: 'rgba(255,255,255,.06)',
          border: '1px solid rgba(200,169,110,.2)',
          borderTop: '2px solid var(--gold)'
        }} data-id="element-270">
              <span className="text-xl mb-2 block" data-id="element-271">{item.icon}</span>
              <h4 className="font-serif text-[16px] font-medium mb-1.5" style={{
            color: 'var(--gold-light)'
          }} data-id="element-272">
                {item.title}
              </h4>
              <p className="text-[12px] leading-relaxed" style={{
            color: 'rgba(255,255,255,.6)'
          }} data-id="element-273">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}